import clsx from 'clsx';
import { baseButtonClass } from '../index';
import { PowerSettingsNew, TransitEnterexit } from '@material-ui/icons';
import { RemoteButton } from '../../../../hooks/useRemote';
import { IconButton } from '../../../../components/IconButton';
import { Tooltip } from '../../../../components/Tooltip';
import { useCitrusView } from '../../../../contexts/CitrusViewContext';

interface Props {
  buttons: RemoteButton[];
  onClick(commandId: number): void;
  onHide(): void;
}

export const PowerOther = ({ buttons, onClick, onHide }: Props) => {
  const { hideRemote } = useCitrusView();
  const getButton = (name: string) =>
    buttons.find((button) => button.name.toUpperCase() === name.toUpperCase());

  const handlePress = (name: string) => {
    const button = getButton(name);
    if (button === undefined) return undefined;
    return onClick(button.id);
  };

  return (
    <div className="inline-flex items-center justify-between col-span-full w-full mb-2">
      <button
        disabled={Boolean(getButton('POWER')) === false}
        className={clsx(baseButtonClass, '!rounded-full !w-[35px] !h-[35px]', {
          'scale-75': window.devicePixelRatio > 1,
        })}
        onClick={() => handlePress('POWER')}
        onTouchEnd={() => handlePress('POWER')}
      >
        <PowerSettingsNew fontSize="small" />
      </button>
      <Tooltip title="Hide Remote">
        <IconButton
          onClick={() => {
            hideRemote(true);
            onHide();
          }}
          onTouchEnd={() => {
            hideRemote(true);
            onHide();
          }}
        >
          <TransitEnterexit />
        </IconButton>
      </Tooltip>
    </div>
  );
};
